/* eslint-disable no-use-before-define */
import { DocumentInterface } from '../models/Document';
import { EDossierGroupType } from '../models/DossierGroup';

export enum UserAccountRoleEnum {
	client = 'client',
	thirdParty = 'thirdParty',
	caregiver = 'caregiver',
	adminCaregiver = 'adminCaregiver',
	administration = 'administration',
}

export enum UserRelationRoleEnum {
	client = 'client',
	responsibleParty = 'responsibleParty',
	thirdParty = 'thirdParty',
	caregiver = 'caregiver',
	administrator = 'administrator',
}

export interface SingleUser {
  id: number;
  accountId?: number;
  name: string;
  accountRole: UserAccountRoleEnum;
  initials?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string|Date;
  createdAt?: string|Date;
  lastActivity?: string|Date;
}

export interface UserRole {
	id: number;
	relationRole: UserRelationRoleEnum;
	roleForUser: SingleUser;
}

export interface ChatResponseMessage {
	id: number,
	message: string,
	sendByName: string,
	timestamp: string
}

export interface ChatResponse {
	messages: ChatResponseMessage[]
}

export enum MeasurementTypeEnum {
  TENSION = 'tension',
  CREDIBILITY = 'credibility',
}

export interface MeasurementInterface {
  id?: number;
  type: MeasurementTypeEnum;
  start: number;
  end: number;
  question: string;
  answer?: number;
  createAt?: Date|string;
  answerAt?: Date|string;
}

export interface CreateMeasurementRequest extends MeasurementInterface {
	forFile: number;
}

export type MeasurementResponse = MeasurementInterface;

export type DocumentResponse = DocumentInterface;

export interface FileResponse {
	id: number;
	name: string;
  archived: boolean;
	users: FileRelationResponse[];
}

export interface FileRelationResponse {
	id: number;
	relationRole: UserRelationRoleEnum;
	userId: SingleUser;
	fileId?: FileResponse;
}

export interface DossierGroupResponse {
	id: number;
	name: string;
	type: EDossierGroupType;
	users: SingleUser[];
}

export interface DossierResponse {
	id: number;
	createdAt: string;
  lastActivityAt: string;
	name: string;
  archived: boolean;
	relations: DossierRelationResponse[];
	aboutUser: SingleUser;
}

export interface DossierRelationResponse {
	id: number;
	relationRole: UserRelationRoleEnum;
	user: SingleUser;
}

export interface CreateClientRequest {
  carewebId?: number;
  initials?: string;
  lastName?: string;
  firstName?: string;
  dateOfBirth?: string;
  email?: string;
  createDossier?: {
    caregiverId: number;
  };
  addToDossier?: {
    role: UserRelationRoleEnum;
    dossierId: number;
  };
}

export interface IFindPersonRequest {
	carewebId?: number;
  initials?: string;
  lastName?: string;
  firstName?: string;
  dateOfBirth?: string;
}

export interface IDossierMetadataResponse {
	dossierId: number;
	caregiverName: string;
	clientName: string;
}

export interface IAppointmentResponse {
  id: number;
  startDateTime: string;
  endDateTime: string;
  activityName: string;
	remarks?: string;
	caregivers: SingleUser[];
}

export interface IUnreadStatus {
  chat: { [groupId: string]: number },
}

export interface IMultiDossierUnreadStatus {
  [dossierId: number]: IUnreadStatus;
}

export interface IGetCustomAppointmentResponse {
	id: number;
	relationId: number;
  text: string;
}

export interface ISetCustomAppointmentRequest {
	relationId: number;
	text: string;
}

export interface ILibraryItemResponse {
  id: number;
  libraryId: number;
  type: string;
  title: string;
  excerpt?: string;
  published: boolean;
  parentId?: number;
  url: string;
  createdAt: string|Date;
  updatedAt: string|Date;
}

export interface IFormSubmissionMeta {
  id: number;
  createdAt: string|Date;
}

export interface IFormSubmissionListItem {
  id: number;
  name: string;
  submissions: IFormSubmissionMeta[];
}

export type TFormSubmissionsListResponse = {
  [formId: string]: IFormSubmissionListItem;
};

export interface ILibraryFormSubmissionResponse {
  id: number;
  dossierRelationId: number;
  libraryItemId: number;
  libraryId: number;
  formId: number;
  name: string;
  raw: any[]|string;
  html: string;
  createdAt: string|Date;
}

export interface ICreateAppointment {
  forDossierRelationIds: number[];
  date?: string;
  time?: string;
  location?: string;
  description?: string;
}

export interface ICreatePerson {
  carewebId?: number;
  initials: string;
  lastName: string;
  firstName: string;
  dateOfBirth: string;
}

export interface IUpdatePerson {
  initials?: string;
  lastName?: string;
  firstName?: string;
  dateOfBirth?: string;
}
